export const thunkTypes = {
  SUBMIT_DAY_CLOSE: `dayClose/submit`,
  CHECK_DAY_CLOSE: `dayClose/check`,
};
